import { useQuery, useQueryClient } from "@tanstack/react-query";
import { GetMentorCohorts, GetMyCohorts } from "../services/cohortService";
import { updateCohortTimezone } from "./cohortHelpers";

export const useCohorts = (username) => {
  const key = "appCohorts";

  // Queries
  const query = useQuery({
    queryKey: [key, username],
    queryFn: async () => {
      const data = await GetMyCohorts(); //GetMentorCohorts(username);
      return updateCohortTimezone(data.data.data);
    },
  });

  return query;
};
